<template>
  <div style="padding-left: 20px;padding-right: 20px;">
    <el-row style="height: 90vh;">
      <el-col :span="24" style="height: 100%;">
        <el-card shadow="none" class="blogList">
          <h1 class="title">
            欢迎来到Dream的时光博客
          </h1>

          <h2 class="introduction">这是我的时光博客，会分享一个关于编程，开发以及其他方面的内容，希望可以对您有所帮助</h2>
          <div class="bounce down" @click="scrollToView">
            <i class="el-icon-arrow-down" style="color: white"></i>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <div id="content" class="content">
      <div class="content-left">
        <div class="all-blog-scope">
          <div class="blog-tips">
            <i v-show="leftItem.isShowBack" @click="back"
               style="margin-right: 4px;margin-left:-4px;font-size: 22px;cursor: pointer"
               class="el-icon-back"></i>
            <h2 class="blog">{{ selectState === 0 ? "全部文章" : categoryName }}</h2>
            <h2 class="blog align-right">共 {{ leftItem.totalCount }} 篇</h2>
          </div>

          <div class="underscore"></div>

          <div :id="'blog-content'+index" class="blog-content" @click="openArticle(item.id)"
               v-for="(item,index) of leftItem.items">
            <div>
              <img style="border-radius: 10px" :src="item.firstImage" width="200px" height="180px">
            </div>
            <div class="blog-main">
              <h4 style="margin:0;width:560px;">{{ item.title }}</h4>
              <p class="blog-description">{{ item.introduction }}</p>
              <div style="display: flex">
                <div style="display: flex;align-items: center;">
                  <img :src="item.headPortraitUrl" width="25px" height="25px" style="border-radius: 50%;">
                  <span class="blog-author">{{ item.adminName }}</span>
                </div>
                <div style="display: flex;align-items: center;">
                  <span class="blog-bottom-text"><i style="margin-right: 3px"
                                                    class="el-icon-date"></i>{{
                      item.createTime
                    }}</span>
                </div>
                <div style="display: flex;align-items: center;">
								<span class="blog-bottom-text">
                  <i class="el-icon-view" style="margin-right: 3px"></i>{{ item.viewCount }}</span>
                </div>
                <div :id="'tag'+index" style="background-color: #fff;height: 34px;margin: 0 20px 0 auto;display: flex;align-items: center;
                border: 1px solid #b3d8ff;border-radius: 5px;color:#409eff;font-size: 12px;padding: 0 10px">
                  <span style="margin: 0 auto">{{ item.categoryName }}</span>
                </div>
              </div>
            </div>
          </div>
          <el-pagination
            class="pagination"
            style="color: #409EFF"
            background
            layout="total,prev, pager, next,jumper"
            :current-page.sync="leftItem.currentPage"
            @current-change="currentChange"
            :page-size="5"
            :total="leftItem.totalPage">
          </el-pagination>
        </div>
      </div>

      <div class="content-right">
        <div class="category">
          <div class="category-title">
            <h3>分类</h3>
          </div>
          <div class="category-content">
            <div @click="categoryClick(item.id,item.name)"
                 :class="index===0?'category-content-item category-content-item-border-topOrBottom':'category-content-item category-content-item-border-bottom'"
                 v-for="(item,index) of rightItem">
              <img :src="item.imagePath" style="margin-left: 4px" width="25px" height="25px"
                   class="bounce">
              <span class="category-content-title">{{ item.name }}</span>
              <span class="category-item-count">{{ item.count }}</span>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import request from "../utils/axiosUtils";
import base_url from "../utils/Constants";
import locationRequest from "../utils/LocationUtils";

export default {
  name: "Home",
  data() {
    return {
      //0 为正常查询  1为分类查询
      selectState: 0,
      leftItem: {
        totalPage: 0,
        totalCount: 5,
        currentPage: 1,
        isShowBack: false,
        items: [
          {
            id: '',
            adminName: '',
            headPortraitUrl: '',
            firstImage: "",
            categoryName: '',
            title: '',
            introduction: '',
            viewCount: '',
            createTime: '',
          },
        ]
      },
      categoryId: null,
      categoryName: null,
      rightItem: [
        {
          id: null,
          class: 'category-content-item category-content-item-border-topOrBottom',
          imagePath: '',
          name: '',
          count: ''
        },
      ],
    }
  },
  methods: {
    //跳转到博客详情页
    openArticle(blogId) {
      //第一种方式，看得见请求参数
      /*this.$router.push({
        path: '/articleContent',
        query: {blogId: blogId}
      });*/
      //第二种方式，看不见请求参数
      this.$router.push({
        name: "ArticleContent",
        path: '/articleContent',
        params: {
          blogId: blogId
        }
      })
    },
    //向下滚动
    scrollToView() {
      this.$nextTick(() => {
        document.getElementById('content').scrollIntoView({
          block: 'start',
          inline: 'nearest',
          behavior: 'smooth'
        });
      })
    },
    //获取博客内容
    getBlog() {
      request({
        url: '/blog/getBlog',
        method: 'get',
        params: {
          page: this.leftItem.currentPage
        }
      }).then(response => {
        let data = response.data.data;
        data.forEach(value => {
          value.createTime = this.handleTime(value.createTime)
          value.headPortraitUrl = base_url + "/getImage/" + value.headPortraitUrl;
          value.firstImage = base_url + "/getImage/" + value.firstImage;
        })
        this.leftItem.items = data;
        this.setItemOver();
      })
    },
    //分类查询博客内容
    categorySelectBlog() {
      request({
        url: '/blog/getBlogByCategory/' + this.categoryId + "/" + this.leftItem.currentPage,
        method: 'get',
      }).then(response => {
        // console.log(response)
        let data = response.data.data;
        data.forEach(value => {
          value.createTime = this.handleTime(value.createTime)
          value.headPortraitUrl = base_url + "/getImage/" + value.headPortraitUrl;
          value.firstImage = base_url + "/getImage/" + value.firstImage;
        })
        this.leftItem.items = data;
        this.setItemOver();
      })
    },
    //给每一个item设置over效果
    setItemOver() {
      let that = this;
      setTimeout(function () {
        for (let i = 0; i < that.leftItem.items.length; i++) {
          let blogContent = document.getElementById('blog-content' + i);
          let tag = document.getElementById('tag' + i);
          blogContent.onmouseover = function () {
            tag.style.backgroundColor = "rgb(58,142,230)"
            tag.style.color = "rgb(255,255,255)"
          }
          blogContent.onmouseleave = function () {
            tag.style.backgroundColor = "rgb(255,255,255)"
            tag.style.color = "#409eff"
          }
        }
      }, 100)

    },
    //获取博客的总篇数
    getBlogCount() {
      request({
        url: '/blog/getBlogCount',
        method: 'get'
      }).then(response => {
        // console.log(response)
        let number = response.data.data;
        this.leftItem.totalPage = number;
        this.leftItem.totalCount = number;
      })
    },
    //获取分类查询的总篇数量
    getBlogSelectCount() {
      request({
        url: '/blog/getBlogCount/' + this.categoryId,
        method: 'get'
      }).then(response => {
        let number = response.data.data;
        this.leftItem.totalPage = number;
        this.leftItem.totalCount = number;
      })
    },
    handleTime(date) {
      let time = new Date(
        date.substr(0, 4),
        parseInt(date.substr(5, 2)) - 1,
        date.substr(8, 2),
        date.substr(11, 2),
        date.substr(14, 2),
        date.substr(17, 2),
      );
      let year = time.getFullYear();
      let month = this.handleZero(time.getMonth() + 1);
      let day = this.handleZero(time.getDate());
      let hours = this.handleZero(time.getHours());
      let minutes = this.handleZero(time.getMinutes());
      let seconds = this.handleZero(time.getSeconds());
      return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds
    },
    handleZero(time) {
      if (time < 10) {
        return '0' + time;
      } else {
        return time
      }
    },
    //获取分类
    getCategories() {
      request({
        url: '/blog/getCategories',
        method: 'get',
      }).then(response => {
        // console.log(response)
        let data = response.data.data;
        for (let datum of data) {
          datum.imagePath = base_url + "/getImage/" + datum.imagePath;
        }
        this.rightItem = data;
      })
    },
    //分类的点击事件 id  分类id
    categoryClick(id, name) {
      this.leftItem.isShowBack = true;
      this.selectState = 1;
      this.categoryName = name;
      this.categoryId = id;
      this.leftItem.currentPage = 1;
      //保存状态
      window.sessionStorage.setItem("categoryName", name);
      window.sessionStorage.setItem("categoryId", id);
      this.handleSelect();
      this.getBlogSelectCount();
    },
    //返回按钮，点击可以回到正常查询
    back() {
      this.leftItem.isShowBack = false;
      this.selectState = 0;
      this.leftItem.currentPage = 1;

      this.handleSelect()
      this.getBlogCount();
    },
    //当前页改变(分页)
    currentChange(val) {
      window.sessionStorage.setItem("currentPage", this.leftItem.currentPage);
      this.leftItem.currentPage = val;
      this.handleSelect();
    },
    //处理查询的分支
    handleSelect() {
      window.sessionStorage.setItem("selectState", this.selectState);
      if (this.selectState === 0) {
        this.getBlog();
      } else {
        //分类查询
        this.categorySelectBlog()
      }
    }
  },
  mounted() {
    /*    let categoryName = window.sessionStorage.getItem("categoryName");
        let categoryId = window.sessionStorage.getItem("categoryId");
        let currentPage = window.sessionStorage.getItem("currentPage");
        let selectState = window.sessionStorage.getItem("selectState");
        if (selectState !== null && selectState === '0') {
          this.selectState = parseInt(selectState);
        } else if (selectState === '1' && categoryId !== null && categoryName !== null) {
          this.categoryId = categoryId;
          this.categoryName = categoryName;
        }
        if (currentPage !== null) {
          this.leftItem.currentPage = parseInt(currentPage);
          alert(this.leftItem.currentPage)
        }
        console.log(categoryName, categoryId,  parseInt(currentPage), parseInt(selectState))*/
    this.getBlog();
    this.getBlogCount();
    this.getCategories();

/*    let key = 'fe5f5abdb0a580233374a97ff1bdc679';
    locationRequest({
      url: '/ip',
      params: {
        key: key,
        type: '4'
      },
      method: 'get',
    }).then(response => {
      console.log(response);
      let rectangle = response.data.rectangle;
      let locations = rectangle.toString().split(";");
      console.log(locations[0] + "|" + locations[1])
      locationRequest({
        url: '/geocode/regeo',
        params: {
          key: key,
          location: locations[0] + "|" + locations[1],
          radius: 1000,
          extensions: "all"
        }
      }).then(response => {
        console.log(response.data.regeocode.formatted_address);
      })
    })*/
  },
}
</script>
<style scoped>
/*分页*/
.pagination {
  position: relative;
  margin-top: 30px;
  margin-bottom: 30px;
}

.blogList {
  background-color: rgba(0, 0, 30, 0.2);
  border: none;
  top: 4%;
  height: 92%;
  position: relative;
}

.title {
  box-sizing: border-box;
  position: relative;
  width: 800px;
  height: max-content;
  line-height: 100px;
  box-shadow: inset 0 0 0 1px white;
  margin: 40px auto;
  margin-top: 80px;
  color: white;
  text-align: center;
  font-size: 50px;
  font-weight: normal;
  letter-spacing: 10px;
}

.introduction {
  box-sizing: border-box;
  position: relative;
  width: 760px;
  height: max-content;
  line-height: 50px;
  margin: 40px auto 0 auto;
  color: white;
  text-align: center;
  font-size: 24px;
  font-weight: normal;
  letter-spacing: 10px;
}

.down {
  animation: bounce 2s infinite;
  animation-duration: 3s;
  font-size: 25px;
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px solid #fff;
}

.down:hover {
  animation: none;
  cursor: pointer;
  box-shadow: 0 0 20px 0 white;
  transition: all .2s;
}

@keyframes clipMe {

  0%,
  100% {
    clip: rect(0px, 806px, 6px, 0px);
  }

  25% {
    clip: rect(0px, 6px, 112px, 0px);
  }

  50% {
    clip: rect(112px, 812px, 112px, 0px);
  }

  75% {
    clip: rect(0px, 812px, 112px, 806px);
  }
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translate(-50%, 0);
  }
  40% {
    transform: translate(-50%, -30px);
  }
  60% {
    transform: translate(-50%, -15px);
  }
}

.content {
  position: relative;
  height: max-content;
  display: flex;
  width: 1100px;
  font-size: 20px;
  margin: 30px auto 0 auto;
}

.content .blog {
  display: inline;
  color: #000;
  font-size: 20px;
}

.content .align-right {
  float: right;
  margin: 0;
}

.underscore {
  border-bottom: 1px #cccccc solid;
  padding-bottom: 0;
}

.blog-tips {
  padding: 15px 20px 10px;
  background-color: rgba(255, 255, 255, 0.85);
}

.blog-content {
  padding: 15px 10px 10px 10px;
  display: flex;
  align-items: center;
  border-bottom: 1px #E6A23C solid;
  background-color: rgba(255, 255, 255, 0.85);
}

.blog-content:hover {
  background-color: rgba(196, 221, 246, 1);
  cursor: pointer;
}

.blog-main {
  margin: 0 0 0 20px;
}

.blog-description {
  overflow: hidden;
  height: 70px;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 2px;
}

.blog-author {
  cursor: pointer;
  margin-left: 5px;
  font-size: 13px;
  font-weight: bold;
}

.blog-bottom-text {
  margin-left: 35px;
  font-size: 13px;
}

.content-left {
  border-radius: 6px;
  width: 800px;
}

.content-right {
  display: flex;
  border-radius: 6px;
  background-color: rgba(255, 255, 255, 0.85);
  width: 280px;
  height: max-content;
  position: relative;
  left: 20px;
}

.category {
  padding: 16px;
  width: 100%;
}

h3 {
  margin: 0;
}

.bounce {
  border-radius: 50%;
}

.category-title {
  font-size: 15px;
  font-weight: normal;
}

.category-content {
  margin-top: 10px;
  font-size: 14px;
}

.category-content-item {
  align-items: center;
  display: flex;
  padding-top: 7px;
  padding-bottom: 7px;
}

.category-content-item-border-bottom {
  border-bottom: 1px rgba(64, 158, 255, 0.3) solid;
}

.category-content-item-border-topOrBottom {
  border-top: 1px rgba(64, 158, 255, 0.3) solid;
  border-bottom: 1px rgba(64, 158, 255, 0.3) solid;
}

.category-content-item:hover {
  background-color: rgba(182, 211, 241, 0.9);
  border-bottom: 1px rgba(182, 211, 241, 0.9) solid;
  cursor: pointer;
}

.category-content-item .category-content-title {
  margin-left: 10px;
  font-size: 16px;
}

.category-item-count {
  float: right;
  margin: 0 15px 0 auto;
  font-size: 16px;
}

</style>



// WEBPACK FOOTER //
// src/components/Home.vue